var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomEdges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 24,
    viewBox: "0 0 139 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127 24C133.627 24 139 18.6274 139 12C139 5.37258 133.627 0 127 0C120.373 0 115 5.37258 115 12C115 18.6274 120.373 24 127 24Z",
    fill: "url(#paint0_linear_3781_71720)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127 0H14V24H127V0Z",
    fill: "url(#paint1_linear_3781_71720)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3781_71720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.4675 10.8977H48.6828C48.6364 10.6951 48.5552 10.517 48.4392 10.3636C48.3253 10.2102 48.186 10.0814 48.0215 9.97727C47.8591 9.87121 47.6787 9.79167 47.4805 9.73864C47.2822 9.68561 47.0755 9.65909 46.8603 9.65909C46.468 9.65909 46.1125 9.74811 45.794 9.92614C45.4776 10.1042 45.2255 10.3665 45.0378 10.7131C44.8522 11.0597 44.7594 11.4848 44.7594 11.9886C44.7594 12.4924 44.8522 12.9176 45.0378 13.2642C45.2255 13.6108 45.4776 13.8731 45.794 14.0511C46.1125 14.2292 46.468 14.3182 46.8603 14.3182C47.0755 14.3182 47.2822 14.2917 47.4805 14.2386C47.6787 14.1856 47.8591 14.107 48.0215 14.0028C48.186 13.8968 48.3253 13.767 48.4392 13.6136C48.5552 13.4583 48.6364 13.2803 48.6828 13.0795H49.4675C49.4084 13.3769 49.3008 13.643 49.1447 13.8778C48.9886 14.1127 48.7946 14.3125 48.5626 14.4773C48.3305 14.6402 48.07 14.7642 47.781 14.8494C47.4942 14.9347 47.1873 14.9773 46.8603 14.9773C46.3076 14.9773 45.8162 14.8561 45.3859 14.6136C44.9555 14.3712 44.617 14.0265 44.3702 13.5795C44.1234 13.1326 44 12.6023 44 11.9886C44 11.375 44.1234 10.8447 44.3702 10.3977C44.617 9.95076 44.9555 9.60606 45.3859 9.36364C45.8162 9.12121 46.3076 9 46.8603 9C47.1873 9 47.4942 9.04261 47.781 9.12784C48.07 9.21307 48.3305 9.33807 48.5626 9.50284C48.7946 9.66572 48.9886 9.86458 49.1447 10.0994C49.3008 10.3324 49.4084 10.5985 49.4675 10.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9878 9.07953H55.7724V12.9318C55.7724 13.3295 55.6681 13.6847 55.4593 13.9972C55.2526 14.3078 54.9604 14.553 54.5829 14.733C54.2053 14.911 53.7623 15 53.254 15C52.7456 15 52.3026 14.911 51.9251 14.733C51.5475 14.553 51.2543 14.3078 51.0454 13.9972C50.8387 13.6847 50.7354 13.3295 50.7354 12.9318V9.07953H51.5201V12.875C51.5201 13.1591 51.5897 13.4119 51.7289 13.6335C51.8681 13.8532 52.0664 14.0265 52.3237 14.1534C52.5832 14.2784 52.8932 14.3409 53.254 14.3409C53.6147 14.3409 53.9247 14.2784 54.1842 14.1534C54.4436 14.0265 54.6418 13.8532 54.7789 13.6335C54.9181 13.4119 54.9878 13.1591 54.9878 12.875V9.07953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8832 10.5341C60.8452 10.2462 60.6912 10.0227 60.4212 9.86364C60.1512 9.70455 59.82 9.625 59.4277 9.625C59.1408 9.625 58.8898 9.66667 58.6747 9.75C58.4616 9.83333 58.295 9.94792 58.1747 10.0938C58.0566 10.2396 57.9975 10.4053 57.9975 10.5909C57.9975 10.7462 58.0387 10.8797 58.1209 10.9915C58.2053 11.1013 58.3129 11.1932 58.4437 11.267C58.5745 11.339 58.7116 11.3987 58.855 11.446C58.9984 11.4915 59.1303 11.5284 59.2505 11.5568L59.9086 11.7159C60.0774 11.7557 60.2651 11.8106 60.4718 11.8807C60.6807 11.9508 60.88 12.0464 61.0698 12.1676C61.2618 12.2869 61.42 12.4403 61.5444 12.6278C61.6689 12.8153 61.7311 13.0455 61.7311 13.3182C61.7311 13.6326 61.6394 13.9167 61.4559 14.1705C61.2744 14.4242 61.0087 14.6259 60.6585 14.7756C60.3105 14.9252 59.8875 15 59.3897 15C58.9257 15 58.5238 14.9328 58.1842 14.7983C57.8467 14.6638 57.5809 14.4763 57.3869 14.2358C57.1949 13.9953 57.0863 13.7159 57.061 13.3977H57.871C57.8921 13.6174 57.9743 13.7992 58.1178 13.9432C58.2633 14.0852 58.4468 14.1913 58.6683 14.2614C58.8919 14.3295 59.1324 14.3636 59.3897 14.3636C59.6893 14.3636 59.9582 14.3201 60.1966 14.233C60.4349 14.1439 60.6237 14.0208 60.7629 13.8636C60.9021 13.7045 60.9718 13.5189 60.9718 13.3068C60.9718 13.1136 60.9116 12.9564 60.7914 12.8352C60.6712 12.714 60.513 12.6155 60.3168 12.5398C60.1206 12.464 59.9086 12.3977 59.6808 12.3409L58.8835 12.1364C58.3772 12.0057 57.9765 11.8191 57.6811 11.5767C57.3858 11.3343 57.2382 11.017 57.2382 10.625C57.2382 10.2992 57.3363 10.0152 57.5324 9.77273C57.7307 9.52841 57.9965 9.33902 58.3298 9.20455C58.6652 9.06818 59.0396 9 59.453 9C59.8707 9 60.2419 9.06723 60.5668 9.2017C60.8916 9.33428 61.1489 9.5161 61.3388 9.74716C61.5307 9.97822 61.632 10.2405 61.6425 10.5341H60.8832Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.667 9.70453V9.07953H67.527V9.70453H65.4893V14.8977H64.7046V9.70453H62.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9359 11.9886C73.9359 12.6023 73.8125 13.1326 73.5657 13.5795C73.3189 14.0265 72.9803 14.3712 72.55 14.6136C72.1197 14.8561 71.6282 14.9773 71.0756 14.9773C70.5229 14.9773 70.0314 14.8561 69.6011 14.6136C69.1708 14.3712 68.8322 14.0265 68.5854 13.5795C68.3387 13.1326 68.2153 12.6023 68.2153 11.9886C68.2153 11.375 68.3387 10.8447 68.5854 10.3977C68.8322 9.95076 69.1708 9.60606 69.6011 9.36364C70.0314 9.12121 70.5229 9 71.0756 9C71.6282 9 72.1197 9.12121 72.55 9.36364C72.9803 9.60606 73.3189 9.95076 73.5657 10.3977C73.8125 10.8447 73.9359 11.375 73.9359 11.9886ZM73.1765 11.9886C73.1765 11.4848 73.0826 11.0597 72.8949 10.7131C72.7093 10.3665 72.4572 10.1042 72.1387 9.92614C71.8223 9.74811 71.4679 9.65909 71.0756 9.65909C70.6832 9.65909 70.3278 9.74811 70.0093 9.92614C69.6929 10.1042 69.4408 10.3665 69.2531 10.7131C69.0674 11.0597 68.9746 11.4848 68.9746 11.9886C68.9746 12.4924 69.0674 12.9176 69.2531 13.2642C69.4408 13.6108 69.6929 13.8731 70.0093 14.0511C70.3278 14.2292 70.6832 14.3182 71.0756 14.3182C71.4679 14.3182 71.8223 14.2292 72.1387 14.0511C72.4572 13.8731 72.7093 13.6108 72.8949 13.2642C73.0826 12.9176 73.1765 12.4924 73.1765 11.9886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2554 9.07953H76.1919L78.3941 13.9091H78.47L80.6722 9.07953H81.6088V14.8977H80.8747V10.4773H80.8114L78.7864 14.8977H78.0777L76.0527 10.4773H75.9894V14.8977H75.2554V9.07953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.688 14.8977V9.07953H89.5988V9.70453H86.4727V11.6705H89.3963V12.2955H86.4727V14.2727H89.6494V14.8977H85.688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0129 14.8977H91.0132V9.07953H93.1015C93.7301 9.07953 94.268 9.196 94.7151 9.42896C95.1623 9.66002 95.5051 9.9924 95.7435 10.4261C95.9818 10.858 96.101 11.375 96.101 11.9773C96.101 12.5833 95.9808 13.1051 95.7403 13.5426C95.4998 13.9782 95.1497 14.3134 94.6898 14.5483C94.23 14.7813 93.671 14.8977 93.0129 14.8977ZM91.7979 14.2727H92.9623C93.498 14.2727 93.9421 14.1799 94.2943 13.9943C94.6466 13.8087 94.9092 13.5445 95.0822 13.2017C95.2551 12.8589 95.3416 12.4508 95.3416 11.9773C95.3416 11.5076 95.2562 11.1032 95.0853 10.7642C94.9145 10.4233 94.6593 10.1619 94.3196 9.98009C93.98 9.79638 93.5571 9.70453 93.0509 9.70453H91.7979V14.2727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.847 10.8977C101.777 10.7064 101.685 10.535 101.572 10.3835C101.46 10.2301 101.326 10.0994 101.17 9.99148C101.016 9.88352 100.841 9.80114 100.645 9.74432C100.448 9.6875 100.233 9.65909 99.9991 9.65909C99.6152 9.65909 99.2661 9.74811 98.9518 9.92614C98.6375 10.1042 98.3876 10.3665 98.2019 10.7131C98.0163 11.0597 97.9235 11.4848 97.9235 11.9886C97.9235 12.4924 98.0174 12.9176 98.2051 13.2642C98.3928 13.6108 98.647 13.8731 98.9676 14.0511C99.2883 14.2292 99.649 14.3182 100.05 14.3182C100.421 14.3182 100.748 14.2472 101.031 14.1051C101.315 13.9612 101.537 13.7585 101.695 13.4972C101.855 13.2339 101.935 12.9242 101.935 12.5682L102.176 12.6136H100.227V11.9886H102.695V12.6136C102.695 13.0928 102.581 13.5095 102.353 13.8636C102.127 14.2178 101.815 14.4924 101.417 14.6875C101.02 14.8807 100.564 14.9773 100.05 14.9773C99.476 14.9773 98.9718 14.8561 98.5373 14.6136C98.1049 14.3712 97.7674 14.0265 97.5248 13.5795C97.2844 13.1326 97.1641 12.6023 97.1641 11.9886C97.1641 11.5284 97.2327 11.1146 97.3698 10.7472C97.509 10.3778 97.7052 10.0634 97.9583 9.80398C98.2114 9.54451 98.511 9.34564 98.8569 9.20739C99.2028 9.06913 99.5836 9 99.9991 9C100.341 9 100.659 9.0464 100.955 9.1392C101.252 9.23011 101.517 9.35985 101.749 9.52841C101.983 9.69508 102.178 9.89489 102.334 10.1278C102.49 10.3589 102.598 10.6155 102.657 10.8977H101.847Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.039 14.8977V9.07953H107.949V9.70453H104.823V11.6705H107.747V12.2955H104.823V14.2727H108V14.8977H104.039Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3781_71720)",
    filter: "url(#filter1_i_3781_71720)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 24C19.6274 24 25 18.6274 25 12C25 5.37258 19.6274 0 13 0C6.37258 0 1 5.37258 1 12C1 18.6274 6.37258 24 13 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5622 7.66453C16.704 7.68484 16.8185 7.72227 16.9287 7.78536C17.1588 7.91904 17.269 8.10083 17.3184 8.43019C17.331 8.52002 17.3573 8.9221 17.3646 9.14667C17.3846 9.7391 17.3951 13.1354 17.3804 14.1513C17.3709 14.8272 17.3604 15.0464 17.3289 15.1993C17.2249 15.704 16.9319 16.073 16.4466 16.3104C16.2061 16.4269 15.9835 16.4954 15.827 16.4975C15.6095 16.5007 15.578 16.4419 15.4835 15.8741C15.4257 15.5244 15.4215 15.5533 15.5455 15.5319C15.6505 15.5148 15.953 15.4078 16.0276 15.3629C16.2061 15.2538 16.3248 15.0603 16.3616 14.8133C16.371 14.7544 16.3731 13.9439 16.371 11.6811L16.3679 8.67362C16.3679 8.64632 16.3506 8.62202 16.3248 8.61306V8.61306C16.2839 8.59808 16.2796 8.59915 16.1515 8.64941C16.0444 8.69219 14.8743 9.29424 13.7841 9.8685C13.1329 10.2107 12.3651 10.6096 12.2916 10.6416C12.1361 10.7112 12.0521 10.709 11.9513 10.6342C11.9051 10.601 11.8799 10.5647 11.7612 10.3625C11.6856 10.2342 11.6173 10.1091 11.6089 10.0856C11.5679 9.96688 11.611 9.85032 11.737 9.74124C11.8074 9.68029 11.8967 9.63216 12.7201 9.21297C13.7305 8.69861 15.0497 8.04522 15.3386 7.91476C15.8448 7.68591 16.1946 7.61534 16.5622 7.66453ZM10.526 7.76077C10.5796 7.78323 10.5995 7.82921 10.5922 7.91048C10.589 7.94684 10.5838 8.10083 10.5806 8.25375C10.5775 8.40667 10.5722 8.5521 10.5691 8.5767V8.5767C10.5661 8.6029 10.5439 8.62268 10.5175 8.62268H10.4882C10.2025 8.62375 9.92628 8.86864 9.79289 9.24291C9.73197 9.41615 9.72672 9.46427 9.68891 10.2749C9.63114 11.4929 9.62589 11.7003 9.62589 12.6007C9.62589 13.5022 9.63639 13.8155 9.68891 14.5042C9.72462 14.9886 9.74563 15.0859 9.85906 15.2934C9.92418 15.4121 9.9935 15.4902 10.0691 15.5276C10.1227 15.5543 10.1395 15.5575 10.2288 15.5565C10.3117 15.5554 10.3422 15.549 10.4126 15.5222C10.4588 15.5051 10.5176 15.4784 10.5439 15.4634C10.7277 15.3586 13.5709 13.9096 13.969 13.7172C14.2074 13.6027 14.2977 13.5846 14.4279 13.6252C14.5382 13.6605 14.5876 13.7043 14.7357 13.9C14.8176 14.0091 14.8659 14.1021 14.8743 14.1716C14.8869 14.2786 14.8187 14.4058 14.7052 14.485C14.6475 14.5256 12.0931 15.8249 11.8253 15.95C11.5679 16.0708 11.4776 16.1179 11.2738 16.2377C10.9094 16.4526 10.6268 16.536 10.2655 16.536C9.8181 16.536 9.49145 16.4002 9.19841 16.0933C9.09443 15.9842 9.0083 15.857 8.93583 15.7072C8.85811 15.5447 8.8203 15.4271 8.78039 15.226C8.71422 14.8945 8.71632 14.9844 8.71632 12.0981C8.71632 10.4609 8.72052 9.43219 8.72682 9.36589C8.75728 9.04294 8.84025 8.76812 8.97679 8.53713C9.24147 8.0912 9.6637 7.81103 10.1721 7.7458C10.275 7.73297 10.4808 7.74152 10.526 7.76077ZM15.0497 10.6224C15.1222 10.6598 15.1611 10.7133 15.2083 10.8384C15.2325 10.9026 15.285 11.0106 15.3249 11.078C15.4541 11.2993 15.4573 11.4062 15.3354 11.4982C15.3092 11.5185 15.0508 11.6533 14.7619 11.7987C14.4721 11.9441 13.6118 12.3804 12.8493 12.7686C12.0868 13.1568 11.4303 13.4872 11.3894 13.5043C11.2707 13.5525 11.1741 13.5439 11.0711 13.4744C11.027 13.4445 10.8443 13.1889 10.7896 13.0819C10.7518 13.0092 10.7487 12.9943 10.7497 12.9215C10.7497 12.8531 10.755 12.8317 10.7833 12.7772C10.8264 12.6927 10.8716 12.6435 10.9493 12.5932C11.0554 12.5237 14.7977 10.6235 14.8607 10.6064C14.9279 10.5882 14.9962 10.5946 15.0497 10.6224Z",
    fill: "url(#paint2_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint3_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint4_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint5_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 5.41462C15.3626 6.82923 15.4773 6.82923 14.9871 6.82923C14.4968 6.82923 14.6118 6.82923 14.6118 5.41462C14.6118 4 14.508 4 14.9873 4C15.4661 4 15.3626 4 15.3626 5.41462Z",
    fill: "url(#paint6_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint7_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint8_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint9_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 5.41462C13.5042 6.82923 13.619 6.82923 13.1287 6.82923C12.6384 6.82923 12.7534 6.82923 12.7534 5.41462C12.7534 4 12.6496 4 13.1289 4C13.6077 4 13.5042 4 13.5042 5.41462Z",
    fill: "url(#paint10_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint11_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint12_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint13_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 5.41462C11.6463 6.82923 11.761 6.82923 11.2708 6.82923C10.7805 6.82923 10.8955 6.82923 10.8955 5.41462C10.8955 4 10.7917 4 11.271 4C11.7498 4 11.6463 4 11.6463 5.41462Z",
    fill: "url(#paint14_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5854C15.3626 20 15.4773 20 14.9871 20C14.4968 20 14.6118 20 14.6118 18.5854C14.6118 17.1708 14.508 17.1708 14.9873 17.1708C15.4661 17.1708 15.3626 17.1708 15.3626 18.5854Z",
    fill: "url(#paint15_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5854C15.3626 20 15.4773 20 14.9871 20C14.4968 20 14.6118 20 14.6118 18.5854C14.6118 17.1708 14.508 17.1708 14.9873 17.1708C15.4661 17.1708 15.3626 17.1708 15.3626 18.5854Z",
    fill: "url(#paint16_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5854C15.3626 20 15.4773 20 14.9871 20C14.4968 20 14.6118 20 14.6118 18.5854C14.6118 17.1708 14.508 17.1708 14.9873 17.1708C15.4661 17.1708 15.3626 17.1708 15.3626 18.5854Z",
    fill: "url(#paint17_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3626 18.5854C15.3626 20 15.4773 20 14.9871 20C14.4968 20 14.6118 20 14.6118 18.5854C14.6118 17.1708 14.508 17.1708 14.9873 17.1708C15.4661 17.1708 15.3626 17.1708 15.3626 18.5854Z",
    fill: "url(#paint18_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5854C13.5042 20 13.619 20 13.1287 20C12.6384 20 12.7534 20 12.7534 18.5854C12.7534 17.1708 12.6496 17.1708 13.1289 17.1708C13.6077 17.1708 13.5042 17.1708 13.5042 18.5854Z",
    fill: "url(#paint19_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5854C13.5042 20 13.619 20 13.1287 20C12.6384 20 12.7534 20 12.7534 18.5854C12.7534 17.1708 12.6496 17.1708 13.1289 17.1708C13.6077 17.1708 13.5042 17.1708 13.5042 18.5854Z",
    fill: "url(#paint20_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5854C13.5042 20 13.619 20 13.1287 20C12.6384 20 12.7534 20 12.7534 18.5854C12.7534 17.1708 12.6496 17.1708 13.1289 17.1708C13.6077 17.1708 13.5042 17.1708 13.5042 18.5854Z",
    fill: "url(#paint21_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5042 18.5854C13.5042 20 13.619 20 13.1287 20C12.6384 20 12.7534 20 12.7534 18.5854C12.7534 17.1708 12.6496 17.1708 13.1289 17.1708C13.6077 17.1708 13.5042 17.1708 13.5042 18.5854Z",
    fill: "url(#paint22_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5854C11.6463 20 11.761 20 11.2708 20C10.7805 20 10.8955 20 10.8955 18.5854C10.8955 17.1708 10.7917 17.1708 11.271 17.1708C11.7498 17.1708 11.6463 17.1708 11.6463 18.5854Z",
    fill: "url(#paint23_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5854C11.6463 20 11.761 20 11.2708 20C10.7805 20 10.8955 20 10.8955 18.5854C10.8955 17.1708 10.7917 17.1708 11.271 17.1708C11.7498 17.1708 11.6463 17.1708 11.6463 18.5854Z",
    fill: "url(#paint24_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5854C11.6463 20 11.761 20 11.2708 20C10.7805 20 10.8955 20 10.8955 18.5854C10.8955 17.1708 10.7917 17.1708 11.271 17.1708C11.7498 17.1708 11.6463 17.1708 11.6463 18.5854Z",
    fill: "url(#paint25_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6463 18.5854C11.6463 20 11.761 20 11.2708 20C10.7805 20 10.8955 20 10.8955 18.5854C10.8955 17.1708 10.7917 17.1708 11.271 17.1708C11.7498 17.1708 11.6463 17.1708 11.6463 18.5854Z",
    fill: "url(#paint26_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88332C7.78555 9.88332 7.78555 9.76576 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77727 5 9.88332 6.39277 9.88332Z",
    fill: "url(#paint27_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88332C7.78555 9.88332 7.78555 9.76576 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77727 5 9.88332 6.39277 9.88332Z",
    fill: "url(#paint28_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88332C7.78555 9.88332 7.78555 9.76576 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77727 5 9.88332 6.39277 9.88332Z",
    fill: "url(#paint29_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 9.88332C7.78555 9.88332 7.78555 9.76576 7.78555 10.2682C7.78555 10.7707 7.78555 10.6528 6.39277 10.6528C5 10.6528 5 10.7592 5 10.2679C5 9.77727 5 9.88332 6.39277 9.88332Z",
    fill: "url(#paint30_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7875C7.78555 11.7875 7.78555 11.6699 7.78555 12.1723C7.78555 12.6749 7.78555 12.557 6.39277 12.557C5 12.557 5 12.6633 5 12.1721C5 11.6814 5 11.7875 6.39277 11.7875Z",
    fill: "url(#paint31_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7875C7.78555 11.7875 7.78555 11.6699 7.78555 12.1723C7.78555 12.6749 7.78555 12.557 6.39277 12.557C5 12.557 5 12.6633 5 12.1721C5 11.6814 5 11.7875 6.39277 11.7875Z",
    fill: "url(#paint32_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7875C7.78555 11.7875 7.78555 11.6699 7.78555 12.1723C7.78555 12.6749 7.78555 12.557 6.39277 12.557C5 12.557 5 12.6633 5 12.1721C5 11.6814 5 11.7875 6.39277 11.7875Z",
    fill: "url(#paint33_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 11.7875C7.78555 11.7875 7.78555 11.6699 7.78555 12.1723C7.78555 12.6749 7.78555 12.557 6.39277 12.557C5 12.557 5 12.6633 5 12.1721C5 11.6814 5 11.7875 6.39277 11.7875Z",
    fill: "url(#paint34_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6917C7.78555 13.6917 7.78555 13.5742 7.78555 14.0766C7.78555 14.5791 7.78555 14.4612 6.39277 14.4612C5 14.4612 5 14.5676 5 14.0763C5 13.5857 5 13.6917 6.39277 13.6917Z",
    fill: "url(#paint35_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6917C7.78555 13.6917 7.78555 13.5742 7.78555 14.0766C7.78555 14.5791 7.78555 14.4612 6.39277 14.4612C5 14.4612 5 14.5676 5 14.0763C5 13.5857 5 13.6917 6.39277 13.6917Z",
    fill: "url(#paint36_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6917C7.78555 13.6917 7.78555 13.5742 7.78555 14.0766C7.78555 14.5791 7.78555 14.4612 6.39277 14.4612C5 14.4612 5 14.5676 5 14.0763C5 13.5857 5 13.6917 6.39277 13.6917Z",
    fill: "url(#paint37_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39277 13.6917C7.78555 13.6917 7.78555 13.5742 7.78555 14.0766C7.78555 14.5791 7.78555 14.4612 6.39277 14.4612C5 14.4612 5 14.5676 5 14.0763C5 13.5857 5 13.6917 6.39277 13.6917Z",
    fill: "url(#paint38_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88332C20.9998 9.88332 20.9998 9.76576 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77727 18.2129 9.88332 19.6064 9.88332Z",
    fill: "url(#paint39_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88332C20.9998 9.88332 20.9998 9.76576 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77727 18.2129 9.88332 19.6064 9.88332Z",
    fill: "url(#paint40_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88332C20.9998 9.88332 20.9998 9.76576 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77727 18.2129 9.88332 19.6064 9.88332Z",
    fill: "url(#paint41_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 9.88332C20.9998 9.88332 20.9998 9.76576 20.9998 10.2682C20.9998 10.7707 20.9998 10.6528 19.6064 10.6528C18.2129 10.6528 18.2129 10.7592 18.2129 10.2679C18.2129 9.77727 18.2129 9.88332 19.6064 9.88332Z",
    fill: "url(#paint42_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7875C20.9998 11.7875 20.9998 11.6699 20.9998 12.1723C20.9998 12.6749 20.9998 12.557 19.6064 12.557C18.2129 12.557 18.2129 12.6633 18.2129 12.1721C18.2129 11.6814 18.2129 11.7875 19.6064 11.7875Z",
    fill: "url(#paint43_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7875C20.9998 11.7875 20.9998 11.6699 20.9998 12.1723C20.9998 12.6749 20.9998 12.557 19.6064 12.557C18.2129 12.557 18.2129 12.6633 18.2129 12.1721C18.2129 11.6814 18.2129 11.7875 19.6064 11.7875Z",
    fill: "url(#paint44_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7875C20.9998 11.7875 20.9998 11.6699 20.9998 12.1723C20.9998 12.6749 20.9998 12.557 19.6064 12.557C18.2129 12.557 18.2129 12.6633 18.2129 12.1721C18.2129 11.6814 18.2129 11.7875 19.6064 11.7875Z",
    fill: "url(#paint45_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 11.7875C20.9998 11.7875 20.9998 11.6699 20.9998 12.1723C20.9998 12.6749 20.9998 12.557 19.6064 12.557C18.2129 12.557 18.2129 12.6633 18.2129 12.1721C18.2129 11.6814 18.2129 11.7875 19.6064 11.7875Z",
    fill: "url(#paint46_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6917C20.9998 13.6917 20.9998 13.5742 20.9998 14.0766C20.9998 14.5791 20.9998 14.4612 19.6064 14.4612C18.2129 14.4612 18.2129 14.5676 18.2129 14.0763C18.2129 13.5857 18.2129 13.6917 19.6064 13.6917Z",
    fill: "url(#paint47_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6917C20.9998 13.6917 20.9998 13.5742 20.9998 14.0766C20.9998 14.5791 20.9998 14.4612 19.6064 14.4612C18.2129 14.4612 18.2129 14.5676 18.2129 14.0763C18.2129 13.5857 18.2129 13.6917 19.6064 13.6917Z",
    fill: "url(#paint48_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6917C20.9998 13.6917 20.9998 13.5742 20.9998 14.0766C20.9998 14.5791 20.9998 14.4612 19.6064 14.4612C18.2129 14.4612 18.2129 14.5676 18.2129 14.0763C18.2129 13.5857 18.2129 13.6917 19.6064 13.6917Z",
    fill: "url(#paint49_linear_3781_71720)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6064 13.6917C20.9998 13.6917 20.9998 13.5742 20.9998 14.0766C20.9998 14.5791 20.9998 14.4612 19.6064 14.4612C18.2129 14.4612 18.2129 14.5676 18.2129 14.0763C18.2129 13.5857 18.2129 13.6917 19.6064 13.6917Z",
    fill: "url(#paint50_linear_3781_71720)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3781_71720",
    x: 40,
    y: 9,
    width: 72,
    height: 14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3781_71720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3781_71720",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3781_71720",
    x: 1,
    y: 0,
    width: 24,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3781_71720"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3781_71720",
    x1: 127,
    y1: 0,
    x2: 127,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D31E72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D31E72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3781_71720",
    x1: 14,
    y1: 24,
    x2: 127,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C0CEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D31E72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3781_71720",
    x1: 13.0518,
    y1: 16.536,
    x2: 13.0518,
    y2: 7.64969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3781_71720",
    x1: 14.9872,
    y1: 4,
    x2: 14.9872,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3781_71720",
    x1: 14.9872,
    y1: 4,
    x2: 14.9872,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3781_71720",
    x1: 14.9872,
    y1: 4,
    x2: 14.9872,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3781_71720",
    x1: 14.9872,
    y1: 4,
    x2: 14.9872,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3781_71720",
    x1: 13.1288,
    y1: 4,
    x2: 13.1288,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3781_71720",
    x1: 13.1288,
    y1: 4,
    x2: 13.1288,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3781_71720",
    x1: 13.1288,
    y1: 4,
    x2: 13.1288,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3781_71720",
    x1: 13.1288,
    y1: 4,
    x2: 13.1288,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3781_71720",
    x1: 11.2709,
    y1: 4,
    x2: 11.2709,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3781_71720",
    x1: 11.2709,
    y1: 4,
    x2: 11.2709,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3781_71720",
    x1: 11.2709,
    y1: 4,
    x2: 11.2709,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3781_71720",
    x1: 11.2709,
    y1: 4,
    x2: 11.2709,
    y2: 6.82923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3781_71720",
    x1: 14.9872,
    y1: 17.1708,
    x2: 14.9872,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3781_71720",
    x1: 14.9872,
    y1: 17.1708,
    x2: 14.9872,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3781_71720",
    x1: 14.9872,
    y1: 17.1708,
    x2: 14.9872,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3781_71720",
    x1: 14.9872,
    y1: 17.1708,
    x2: 14.9872,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3781_71720",
    x1: 13.1288,
    y1: 17.1708,
    x2: 13.1288,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3781_71720",
    x1: 13.1288,
    y1: 17.1708,
    x2: 13.1288,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3781_71720",
    x1: 13.1288,
    y1: 17.1708,
    x2: 13.1288,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3781_71720",
    x1: 13.1288,
    y1: 17.1708,
    x2: 13.1288,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3781_71720",
    x1: 11.2709,
    y1: 17.1708,
    x2: 11.2709,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3781_71720",
    x1: 11.2709,
    y1: 17.1708,
    x2: 11.2709,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3781_71720",
    x1: 11.2709,
    y1: 17.1708,
    x2: 11.2709,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3781_71720",
    x1: 11.2709,
    y1: 17.1708,
    x2: 11.2709,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3781_71720",
    x1: 5,
    y1: 10.2681,
    x2: 7.78555,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3781_71720",
    x1: 5,
    y1: 10.2681,
    x2: 7.78555,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3781_71720",
    x1: 5,
    y1: 10.2681,
    x2: 7.78555,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3781_71720",
    x1: 5,
    y1: 10.2681,
    x2: 7.78555,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3781_71720",
    x1: 5,
    y1: 12.1723,
    x2: 7.78555,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3781_71720",
    x1: 5,
    y1: 12.1723,
    x2: 7.78555,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3781_71720",
    x1: 5,
    y1: 12.1723,
    x2: 7.78555,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_3781_71720",
    x1: 5,
    y1: 12.1723,
    x2: 7.78555,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_3781_71720",
    x1: 5,
    y1: 14.0765,
    x2: 7.78555,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_3781_71720",
    x1: 5,
    y1: 14.0765,
    x2: 7.78555,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_3781_71720",
    x1: 5,
    y1: 14.0765,
    x2: 7.78555,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_3781_71720",
    x1: 5,
    y1: 14.0765,
    x2: 7.78555,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_3781_71720",
    x1: 18.2129,
    y1: 10.2681,
    x2: 20.9998,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_3781_71720",
    x1: 18.2129,
    y1: 10.2681,
    x2: 20.9998,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_3781_71720",
    x1: 18.2129,
    y1: 10.2681,
    x2: 20.9998,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_3781_71720",
    x1: 18.2129,
    y1: 10.2681,
    x2: 20.9998,
    y2: 10.2681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_3781_71720",
    x1: 18.2129,
    y1: 12.1723,
    x2: 20.9998,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_3781_71720",
    x1: 18.2129,
    y1: 12.1723,
    x2: 20.9998,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_3781_71720",
    x1: 18.2129,
    y1: 12.1723,
    x2: 20.9998,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_3781_71720",
    x1: 18.2129,
    y1: 12.1723,
    x2: 20.9998,
    y2: 12.1723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_3781_71720",
    x1: 18.2129,
    y1: 14.0765,
    x2: 20.9998,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_3781_71720",
    x1: 18.2129,
    y1: 14.0765,
    x2: 20.9998,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_3781_71720",
    x1: 18.2129,
    y1: 14.0765,
    x2: 20.9998,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_3781_71720",
    x1: 18.2129,
    y1: 14.0765,
    x2: 20.9998,
    y2: 14.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.385417,
    stopColor: "#6B0BEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661458,
    stopColor: "#D21D71"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3781_71720"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomEdges);
export default __webpack_public_path__ + "static/media/Custom-Edges.87db384acca4617499e9d62a84f50267.svg";
export { ForwardRef as ReactComponent };